export interface ForemanJobCrew {
  foremanJobCrewID: string;
  jobCrewID: string | null;
  name: string | null;
  shift: number | null;
  bActive: boolean;
}
